import React, { PropsWithChildren } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import cx from 'classnames';
import style from './simple-modal.module.scss';

interface SimpleModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  dialogClassName?: string;
  contentClassName?: string;
}

export const SimpleModal: React.FC<PropsWithChildren<SimpleModalProps>> = ({
  isOpen,
  onClose,
  title,
  children,
  dialogClassName,
  contentClassName
}) => {
  return (
    <BootstrapModal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName={cx(style.modalDialog, dialogClassName)}
      contentClassName={cx(style.modalContent, contentClassName)}
    >
      <BootstrapModal.Header closeButton className={style.modalHeader}>
        <BootstrapModal.Title className={style.modalTitle}>
          {title}
        </BootstrapModal.Title>
      </BootstrapModal.Header>

      <BootstrapModal.Body className={style.modalBody}>
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};
